import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntitySearchModalComponent } from './entity-search-modal.component';
import { MaterialModule } from 'src/app/core/shared/util/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingPageModule } from 'src/app/features/loaders/loading-page/loading-page.module';
import { EntityCardBasicModule } from '../../components/entity-card-basic/entity-card-basic.module';
import { EntitySearchService } from '../../services/entity-search.service';
import { EntityModalsService } from '../../services/entity-modals.service';
import { EnableControlModule } from 'src/app/core/shared/util/material/directives/enabled-controls.directive';

@NgModule({
  declarations: [EntitySearchModalComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    LoadingPageModule,
    ReactiveFormsModule,
    EntityCardBasicModule,
    EnableControlModule
  ],
  exports: [EntitySearchModalComponent],
  providers: [EntitySearchService, EntityModalsService]
})
export class EntitySearchModalModule { }
